<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Inbound / Receipt {{ editable ? "Edit" : "Upload" }}
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-card>
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >{{ editable ? "Edit" : "Upload" }} Order

          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form>
          <ul class="text-left mb-2">
            <li>Customer Reference Number has to be unique</li>
          </ul>
        </v-form>
      </v-card-text>
      <v-divider class="mb-3"></v-divider>
      <v-card-text>
        <v-form ref="form">
          <div class="text-center py-0">
            <v-row>
              <v-col md="6" class="pl-3 pb-0" v-if="!editable">
                <v-autocomplete
                  v-model="warehouse"
                  :items="warehouses"
                  item-text="name"
                  item-value="id"
                  label="Select Warehouse"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center required"
                  :rules="[(v) => !!v || 'Please Select Warehouse']"
                  outlined
                  hide-details="auto"
                  @change="
                    getStores(selectedClient, warehouse), fetchClientList()
                  "
                ></v-autocomplete>
              </v-col>
              <v-col md="6" class="pl-3" v-else>
                <v-text-field
                  label="Warehouse"
                  outlined
                  readonly
                  hide-details="auto"
                  v-model="warehouse_name"
                ></v-text-field>
              </v-col>
              <v-col
                md="6"
                v-if="
                  (userCategory.user_category === 3 ||
                    userCategory.user_category === 6) &&
                  !editable
                "
                class="pl-3 pb-0"
              >
                <v-autocomplete
                  v-model="selectedClient"
                  :items="clients"
                  :loading="clientLoader"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center required"
                  :rules="[(v) => !!v || 'Please Select Client']"
                  outlined
                  hide-details="auto"
                  @change="
                    getStores(selectedClient, warehouse),
                      callAPi(selectedClient),
                      supplierDropdown(selectedClient)
                  "
                ></v-autocomplete>
              </v-col>
              <v-col md="6" class="pl-3" v-else>
                <v-text-field
                  label="Client"
                  outlined
                  readonly
                  hide-details="auto"
                  v-model="client_name"
                ></v-text-field>
              </v-col>
              <v-col md="6" class="pb-0 pl-3" v-if="!editable">
                <v-autocomplete
                  v-model="infor_storer_id"
                  label="Storer Name"
                  :rules="[(v) => !!v || 'Storer Name is required.']"
                  item-text="channel_name"
                  item-value="id"
                  class="required"
                  :items="stores"
                  outlined
                  hide-details="auto"
                ></v-autocomplete>
              </v-col>
              <v-col md="6" class="pl-3" v-else>
                <v-text-field
                  label="Storer"
                  outlined
                  readonly
                  hide-details="auto"
                  v-model="storer_name"
                ></v-text-field>
              </v-col>
              <v-col
                md="6"
                class="pb-0 pl-3"
                v-if="supplierList.length > 0 && !editable"
              >
                <v-autocomplete
                  v-model="supplier"
                  hide-details="auto"
                  label="Supplier"
                  :rules="[(v) => !!v || 'Supplier is required.']"
                  :item-text="
                    (item) =>
                      `${item.b2b_supplier_id__supplier_name} - (${item.supplier_code})`
                  "
                  item-value="supplier_code"
                  class="required"
                  :items="supplierList"
                  :readonly="editable"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col md="6" class="pl-3" v-if="editable">
                <v-text-field
                  label="Supplier"
                  outlined
                  readonly
                  hide-details="auto"
                  v-model="suppliertext"
                ></v-text-field>
              </v-col>
              <v-col md="6" class="pl-3">
                <v-text-field
                  outlined
                  hide-details="auto"
                  v-model="receipt_no"
                  class="required"
                  label="Customer Ref. Number"
                  maxlength="50"
                  :rules="[
                    (v) =>
                      (!!v && /^[a-zA-Z0-9/ _:-]+$/.test(v)) ||
                      'Customer Ref. Number accepts only A-Z, a-z, 0-9, / _ - : only.',
                  ]"
                  :readonly="editable"
                ></v-text-field>
              </v-col>

              <v-col md="6" class="pl-3">
                <v-text-field
                  outlined
                  hide-details="auto"
                  v-model="boe"
                  label="BOE"
                  :readonly="editable"
                ></v-text-field>
              </v-col>
              <v-col md="6" class="pl-3">
                <v-text-field
                  outlined
                  v-model="purchase_order"
                  label="Purchase Order"
                  hide-details="auto"
                  :readonly="editable"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="pl-3 pb-0">
                <v-menu
                  v-model="dateMenuExpected"
                  :close-on-content-click="true"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  hide-details="auto"
                  @update:return-value="
                    (val) =>
                      (expected_receipt_date = val || expected_receipt_date)
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(expected_receipt_date)"
                      label="Expected Receipt Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      hide-details="auto"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="expected_receipt_date"
                    @input="dateMenu = false"
                    @click:date="$refs.dateMenu.save(expected_receipt_date)"
                    :min="getStartDate"
                    :reactive="false"
                    v-if="dateMenuExpected"
                    :initial-active-month="() => new Date()"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" class="pl-3">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="true"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  @update:return-value="(val) => (date = val || date)"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(date)"
                      label="Requested Delivery Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      class="required"
                      hide-details="auto"
                      :rules="[
                        (v) => !!v || 'Please Select Requested Delivery Date',
                      ]"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    @input="dateMenu = false"
                    @click:date="$refs.dateMenu.save(date)"
                    :min="getStartDate"
                    :reactive="false"
                    v-if="dateMenu"
                    :initial-active-month="() => new Date()"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="6" class="custom">
                <v-file-input
                  v-model="file"
                  counter
                  show-size
                  accept=".xlsx"
                  class="required"
                  label="Select your Order File"
                  outlined
                  prepend-icon=""
                  prepend-inner-icon="mdi-paperclip"
                  :rules="[(v) => !!v || 'Please Select Order File']"
                  @click="file = null"
                  hide-details="auto"
                >
                </v-file-input>
              </v-col>
            </v-row>
            <v-row class="text-left mt-0">
              <v-col class="pl-3">
                <v-btn
                  color="green"
                  dark
                  class="mr-3"
                  @click="listPage"
                  v-if="checkPermission('app_ecom_vendors:excel_details')"
                >
                  Uploaded List
                </v-btn>
                <v-btn
                  color="primary"
                  dark
                  :loading="fileLoader"
                  @click="upload"
                >
                  Upload
                </v-btn>
                <v-btn
                  color="info"
                  class="ml-3"
                  :loading="downloader"
                  v-if="selectedClient"
                  @click="downloadTemplate()"
                  >Download template</v-btn
                >

                <v-btn class="ml-3" @click="close()"> Cancel </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
    getStartDate() {
      var startDate = new Date();
      startDate.setDate(startDate.getDate() + 1);
      startDate.setHours(0, 0, 0, 0);
      return startDate.toISOString().split("T")[0];
    },
  },
  created() {
    this.getwarehouse();
    if (this.$store.getters.user.user_category === 1) {
      this.selectedClient = this.$store.getters.user.id;
      this.supplierDropdown(this.selectedClient);
      this.getInboundSettings(this.$store.getters.user.id).then((response) => {
        this.newTemplate = response.data.add_sku;
      });
      this.getInforWarehouseListBB(this.$store.getters.user.id).then(
        (response) => {
          this.warehouses = response.data.result;
        }
      );
    }

    if (this.$route.query.key > 0) {
      this.editable = true;
      this.getDetailInbound(this.$route.query.key).then((response) => {
        this.infor_storer_id = response.data.channel_id;
        this.selectedClient = response.data.client_id;
        this.client_name = response.data.client_id__name;
        this.warehouse_name = response.data.warehouse_id__name;
        this.storer_name = response.data.channel_id__channel_name;
        this.receipt_no = response.data.receipt_no;
        this.purchase_order = response.data.purchase_order;
        this.boe = response.data.boe;
        this.date = response.data.delivery_date;
        this.expected_receipt_date = response.data.receipt_date;
        this.warehouse = response.data.warehouse_id;
        this.supplier = response.data.supplier_code;
        this.suppliertext =
          response.data.supplier_name +
          " - " +
          "(" +
          response.data.supplier_code +
          ")";
      });
    }
  },
  mounted() {},
  data() {
    return {
      editable: false,
      date: null,
      dateMenu: false,
      clients: [],
      selectedClient: null,
      total: 0,
      file: null,
      fileLoader: false,
      dialog: false,
      statusType: null,
      downloader: false,
      uploadRes: {},
      clientLoader: false,
      warehouses: [],
      receipt_no: "",
      warehouse: "",
      infor_storer_id: null,
      stores: [],
      expected_receipt_date: null,
      dateMenuExpected: false,
      newTemplate: null,
      supplierList: [],
      supplier: null,
      purchase_order: null,
      boe: null,
      client_name: null,
      warehouse_name: null,
      storer_name: null,
      suppliertext: null,
    };
  },

  methods: {
    ...mapActions([
      "downloadInboundOrderTemplate",
      "uploadinboundList",
      "fetchClient",
      "snackBar",
      "getInforWarehouseListBB",
      "getWarehouseStores",
      "getInboundSettings",
      "getSupplierVisibility",
      "getInforWarehouseListBBInfor",
      "getDetailInbound",
      "updateinboundList",
    ]),
    callAPi(id) {
      this.getInboundSettings(id).then((response) => {
        this.newTemplate = response.data.add_sku;
      });
    },
    supplierDropdown(id) {
      let payload = {
        client_id: id,
      };
      this.getSupplierVisibility(payload).then((res) => {
        this.supplierList = res.data.data.result;
        if (res.data.data.show_dropdown == false) {
          this.supplierList = [];
        }
      });
    },
    getwarehouse() {
      this.warehouse = "";
      this.infor_storer_id = null;

      let payload = {
        b2b_fulfillment: "inbound",
      };
      this.getInforWarehouseListBBInfor(payload).then((response) => {
        this.warehouses = response.data.result;
        if (response.data.result2) {
          this.supplierList = response.data.result2;
        }
      });
    },
    downloadTemplate() {
      this.downloader = true;
      let url = "";
      if (this.newTemplate == false) {
        url = "/api/file_download?file_path=fulfillmentb2b/b2b_inbound.xlsx";
      } else {
        url =
          "/api/file_download?file_path=fulfillmentb2b/b2b_inbound_add_sku.xlsx";
      }
      this.downloadInboundOrderTemplate(url)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },

    upload() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      const payload = new FormData();
      payload.append("data_file", this.file, this.file.name);
      if (
        this.userCategory.user_category === 3 ||
        this.userCategory.user_category === 6
      ) {
        payload.append("client_id", this.selectedClient);
      }
      payload.append("warehouse", this.warehouse);

      payload.append("receipt_no", this.receipt_no);
      payload.append("requested_delivery_date", this.date);
      payload.append("storer_id", this.infor_storer_id);
      if (this.supplier) payload.append("supplier_code", this.supplier);
      if (this.boe) payload.append("boe", this.boe);
      if (this.purchase_order)
        payload.append("purchase_order", this.purchase_order);

      if (this.expected_receipt_date)
        payload.append("expected_receipt_date", this.expected_receipt_date);
      if (this.editable) {
        this.updateinboundList(payload)
          .then((res) => {
            this.fileLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });

            this.$refs.form.reset();
            this.date = null;
            this.$router.push("/inbound-list");
          })
          .catch(() => {
            this.fileLoader = false;
          });
      } else {
        this.uploadinboundList(payload)
          .then((res) => {
            this.fileLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });

            this.$refs.form.reset();
            this.date = null;
            this.$router.push("/inbound-list");
          })
          .catch(() => {
            this.fileLoader = false;
          });
      }
    },
    close() {
      this.selectedClient = null;
      this.file = null;
      this.fileLoader = false;
      this.$refs.form?.reset();
      this.date = null;
      this.$router.push("/inbound-list");
    },
    fetchClientList() {
      if (
        this.userCategory.user_category === 3 ||
        this.userCategory.user_category === 6
      ) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active_facility: 1,
          warehouse_id: this.warehouse,
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    getStores(client, id) {
      let payload = {
        client_id: client,
        warehouse_id: id,
      };
      if (this.selectedClient && this.warehouse)
        this.getWarehouseStores(payload).then((res) => {
          this.stores = res.data;
        });
    },
    listPage() {
      this.$router.push({
        name: "inboundBulkorderStatusList",
        params: {
          type: "inbound_upload,inbound_bulk_upload",
        },
      });
    },
  },
};
</script>
<style>
.custom .v-text-field {
  padding-top: 0;
}
</style>
